document.addEventListener('DOMContentLoaded', function () {
    const rewardPopup = document.getElementById('youtube-reward-popup');

    // Ensure the button exists
    if (!rewardPopup) {
        console.error('YouTube reward button not found.');
        return;
    }

    console.log('YouTube reward button found.');

    // Add click event to the popup button
    rewardPopup.addEventListener('click', function () {
        // Directly notify Smile.io of activity
        Smile.createActivity({ token: 'activity_nwPTe4BqPX952Was4M7K8zr3' })
            .then(function (activity) {
                alert('Thank you for subscribing! You’ve earned 50 points.');
                console.log('Created activity ' + activity.id);

                // Optional: Update metafield to avoid claiming reward multiple times
                fetch('/account', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        metafields: {
                            rewards: {
                                youtube_claimed: true
                            }
                        }
                    })
                })
                    .then(function (response) {
                        if (response.ok) {
                            console.log('Metafield updated successfully.');
                        } else {
                            console.error('Error updating metafield:', response.statusText);
                        }
                    })
                    .catch(function (error) {
                        console.error('Error while updating metafield:', error);
                    });
            })
            .catch(function (err) {
                console.error('Something went wrong with creating the activity:', err);
                alert('Please Sign up & Subscribe Our Youtube Channel to Get Reward.');
            });
    });
});
